import { defineComponent as _defineComponent } from 'vue'
import { mdiEye } from '@mdi/js';
import SdsDateRangeField from '@/components/SdsDateRangeField.vue';
import SdsTextField from '@/components/SdsTextField.vue';
import SdsDataTable from '@/components/SdsDataTable.vue';
import { reloadPage } from '@/utils';
import { SimNao } from '@/types/enum/SimNao';
import { useConsultaParecerReferencialStore } from './store/ConsultaParecerReferencialStore';
import { storeToRefs } from 'pinia';
import ParecerReferencialService from './service/ParecerReferencialService';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultaParecerReferencial',
  setup(__props) {

const store = useConsultaParecerReferencialStore();
const { filter, result } = storeToRefs(store);
const headers = [
  {
    text: 'Processo',
    value: 'processoCompleto',
    align: 'center',
    width: '160px',
  },
  {
    text: 'Parecer',
    value: 'parecerCompleto',
    align: 'center',
    width: '160px',
  },
  {
    text: 'Aprovação da Presidência',
    value: 'dtParecer',
    align: 'center',
    width: '180px',
  },
  {
    text: 'Data Validade',
    value: 'dtValidade',
    align: 'center',
    width: '150px',
  },
  {
    text: 'Inativo',
    value: 'flForaUso',
    align: 'center',
    width: '100px',
  },
  {
    text: 'Disponível na Web',
    value: 'flMostraInternet',
    align: 'center',
    width: '100px',
  },
  {
    text: 'Ação',
    value: 'acao',
    align: 'center',
    width: '120px',
  },
];

const getColor = (valor: SimNao) => {
  return valor === SimNao.FL_NAO ? '#B71D1C' : '#548B2F';
};

const getMasckValor = (
  ano: string,
  numero: string,
  ordem: boolean,
  leftPad: boolean
) => {
  return ordem
    ? ano + '/' + getMasckQtdeCaracter(numero, leftPad)
    : getMasckQtdeCaracter(numero, leftPad) + '/' + ano;
};

const getMasckQtdeCaracter = (valor: string, leftPad: boolean) => {
  if (!leftPad) {
    return valor;
  }
  let valorAtualizado = valor;

  for (let i = valor.length; i < 8; i++) {
    valorAtualizado = 0 + valorAtualizado;
  }

  return valorAtualizado;
};

return { __sfc: true,store, filter, result, headers, getColor, getMasckValor, getMasckQtdeCaracter, mdiEye, SdsDateRangeField, SdsTextField, SdsDataTable, reloadPage, SimNao, ParecerReferencialService }
}

})